import { render, staticRenderFns } from "./SideBtns.vue?vue&type=template&id=90545db2&scoped=true&"
import script from "./SideBtns.vue?vue&type=script&lang=js&"
export * from "./SideBtns.vue?vue&type=script&lang=js&"
import style0 from "./SideBtns.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SideBtns.vue?vue&type=style&index=1&id=90545db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90545db2",
  null
  
)

export default component.exports